module.exports = __webpack_public_path__ + "media/images/help/submission-management-2-496923e4441bd2afa6686ce8236ad7e6.png";